import { Component,ElementRef, Renderer2, HostListener,ViewChild} from '@angular/core';
import SwiperCore,{Autoplay,Keyboard,Pagination,Navigation} from 'swiper';
import { Router, RouterModule } from '@angular/router';
import {MatExpansionModule} from '@angular/material/expansion';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { MatExpansionPanel } from '@angular/material/expansion';
import { OwlOptions } from 'ngx-owl-carousel-o'; 


SwiperCore.use([Autoplay,Pagination,Keyboard,Navigation])

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})
export class BusinessComponent {

  constructor(private router: Router,private el: ElementRef, private renderer: Renderer2){

  }
  showOverlay=true;
  selectedOption: string = 'awb'; 
  panelOpenState = false;

 brandImagesGrouped: any[][] = [];
groupBrandImages() {
  const groupSize = 5; // show 5 logos at a time
  const n = this.brandImages.length;

  this.brandImagesGrouped = [];

  for (let i = 0; i < n; i++) {
    let group = [];
    for (let j = 0; j < groupSize; j++) {
      group.push(this.brandImages[(i + j) % n]); // wrap-around using modulo
    }
    this.brandImagesGrouped.push(group);
  }
}

 
  onClick5(){ 
    let hom=window.location.href
    console.log(hom) 
    this.router.navigate(['/contacts']); 
    setTimeout(()=>{ 
    this.scrollTOView5(); 
    },800) 
  }
  scrollTOView5(){
    window.scrollTo(0, 2);
  } 
  ngOnInit(): void { 
    this.groupBrandImages()
  }
brandImages = [ 
  {
    image: "/assets/images/brands/new_brands/bluedart.png"
  },  
  {
    image: "/assets/images/brands/new_brands/delhivery.png"
  },  
  {
    image: "/assets/images/brands/new_brands/dtdc.png"
  },  
  {
    image: "/assets/images/brands/new_brands/ekart.png"
  },  
  {
    image: "/assets/images/brands/new_brands/xpressbee.png"
  },   

];

customOptions1: OwlOptions = {
  loop:true,
  mouseDrag: true,
  touchDrag: true,
  pullDrag: true,
  dots: false,
  navSpeed: 600,
  navText: ["", ""],
      responsive: {
    0: {
      items: 1,
    },
    400: {
      items: 1,
    },
    425: {
      items: 1,
    },
    320: {
      items: 1,
    },
    760: {
      items: 5,
    },
    768: {
      items: 3,
    },
    1024: {
      items: 5,
    },
    1280: {
      items:5,
    },
    1440: {
      items: 5,
    },
    1920:{
      items:5,
    }
  },
  nav: false,
  autoplay: true, 
  autoplayTimeout: 5000,
};



}




